import React, { useState } from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import 'react-drawer/lib/react-drawer.css';
import { Col, Container, Row, Spinner } from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import ManageDonationsList from './component/ManageDonationsList';
import DonationExportReport from './component/DonationExportReport';
import { EXPORT_ALLOWED_USER_ROLES } from '../../../constants/index';

const ManageDonations = () => {
  const users = JSON.parse(localStorage?.getItem('authUser'));

  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState();
  const [refreshList, setRefreshList] = useState(false);

  return (
    <React.Fragment>
      {loading ? (
        <div className="loader-container">
          <Spinner type="grow" className="ms-2" color="dark" />
        </div>
      ) : (
        <></>
      )}
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Manage Donations</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row className="align-items-center">
            <Col xl={4}>
              <DashBreadcrumb
                title="Donations"
                breadcrumbItem="Manage Donations List"
              />
            </Col>
            <Col xl={8}>
               <div className="d-flex justify-content-end align-items-center mb-3">
                 {EXPORT_ALLOWED_USER_ROLES.includes(String(users?.role_id)) && (
                   <div>
                     <DonationExportReport />
                   </div>
                 )}
               </div>
             </Col>
          </Row>
          <ManageDonationsList stores={stores} refreshList={refreshList} />

        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ManageDonations;
